interface CardProps {
  children: React.ReactNode;
  className?: string;
}

const cardBase =
  "rounded-2xl border border-slate-200/80 dark:border-slate-700/80 bg-white dark:bg-slate-800/95 shadow-sm dark:shadow-none hover:shadow-md dark:hover:shadow-none transition-shadow overflow-hidden";

export function Card({ children, className = "" }: CardProps) {
  return <div className={`${cardBase} ${className}`}>{children}</div>;
}

const headerBase = "px-4 sm:px-5 py-4 border-b border-slate-100 dark:border-slate-700";

export function CardHeader({ children, className = "" }: CardProps) {
  return <div className={`${headerBase} ${className}`}>{children}</div>;
}

export function CardContent({ children, className = "" }: CardProps) {
  return <div className={`px-4 sm:px-5 py-4 ${className}`}>{children}</div>;
}
